import React, { useState } from 'react';
import { Button, InputGroup, Divider, Icon } from '@blueprintjs/core';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import TeachRTooltip from "../../components/Tooltip/TeachRTooltip"
import ScenarioEvent from "../../components/ScenarioEditor/ScenarioEvent";
import './ConfigurationStyle.css';

const ConfigureScenario = () => {
    const [scenarioName, setScenarioName] = useState("");
    const [showScenarioEditor, setShowScenarioEditor] = useState(false);
    const [events, setEvents] = useState([]);
    //const dispatch = useDispatch();

    // Drag and Drop functionality
    const handleOnDragEnd = (result) => {
        if (!result.destination) return;
        const items = Array.from(events);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        setEvents(items);
    };

    // Adding a new Scenario Event
    const addScenarioEvent = () => {
        setEvents([
            ...events,
            { time: '', target: '', actionType: 'sound', actionValue: '', duration: '' }
        ]);
    };

    // Updating a single Scenario Event
    const updateScenarioEvent = (index, updatedEvent) => {
        const newEvents = events.map((event, i) => (i === index ? updatedEvent : event));
        setEvents(newEvents);
    };

    // Deleting a Scenario Event
    const deleteScenarioEvent = (index) => {
        const newEvents = events.filter((_, i) => i !== index);
        setEvents(newEvents);
    };

    /* XML related */
    const handleNewScenario = () => {
        setScenarioName("");
        setEvents([]);
        setShowScenarioEditor(true);
        addScenarioEvent();
    };

    const handleLoadScenario = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(e.target.result, 'application/xml');

            const loadedScenarioName = xmlDoc.getElementsByTagName('ScenarioName')[0].textContent;

            const loadedEvents = Array.from(xmlDoc.getElementsByTagName('ScenarioEventXML')).map(eventNode => {
                const action = eventNode.getElementsByTagName('action')[0].textContent.trim();
                let type = "";
                let value = "";

                if (action.startsWith("anim:")) {
                    type = "anim";
                    value = action.substring(5);
                }
                else if (action.startsWith("sound:")) {
                    type = "sound";
                    value = action.substring(6);
                }
                else {
                    console.log("unknown type of action");
                }

                console.log(`SCENARIO3) action: ${action}, type: ${type}, value: �${value}`);
                logControlChars(value);
                console.log(stringToHexCodes(value));

                const [actionType, actionValue] = action.split(':'); // Decompose into sound:filename or anim:animationname
                const actionValue2 = action.substring(5);
                const fgdjhjhfgdjh = "SCENARIO4)" + action + " actionType " + actionType + " actionValue " + actionValue;
                console.log(`fgdjhfgdjhfgdjh `, fgdjhjhfgdjh);

                //logControlChars(action);
                //console.log(stringToHexCodes(action));

                logControlChars(actionValue);
                console.log(stringToHexCodes(actionValue));

                logControlChars(actionValue2);
                console.log(stringToHexCodes(actionValue2));

                // The second string (action value) seems to have an encryption problem or something similar.
                const cleanedActionValue = actionValue2.replace(/[^\x20-\x7E]/g, '').trim();

                const action2 = action.split(':'); // Decompose into sound:filename or anim:animationname
                console.log(`SCENARIO2) action: ${action2}, type: ${action2[0]}, value: �${action2[1]}`);

                return {
                    time: eventNode.getElementsByTagName('time')[0].textContent,
                    target: eventNode.getElementsByTagName('target')[0].textContent,
                    actionType: actionType,
                    actionValue: actionValue2,
                    duration: eventNode.getElementsByTagName('duration')[0].textContent
                };
            });

            setScenarioName(loadedScenarioName);
            setEvents(loadedEvents);
            setShowScenarioEditor(true);
        };

        reader.readAsText(file, "UTF-8");
    };

    const logControlChars = (str) => {
        for (let i = 0; i < str.length; i++) {
            const code = str.charCodeAt(i);
            if (code < 32 || code === 127 || (code >= 0x200B && code <= 0x200F)) {
                console.log(`CC| Index ${i}: U+${code.toString(16).padStart(4, '0').toUpperCase()} - ${JSON.stringify(str[i])}`);
            }
            else
                console.log("no controll chars found");
        }
    };

    function stringToHexCodes(str) {
        return Array.from(str).map(char =>
            char.charCodeAt(0)
                .toString(16)            
                .padStart(4, '0')        
                .toUpperCase()
        ).join(' ');
    }


    const handleSaveScenario = () => {
        const xmlContent = buildScenarioXML(scenarioName, events);
        const utf8Bom = '\uFEFF';
        const blob = new Blob([utf8Bom + xmlContent], { type: 'application/xml' });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `${scenarioName || 'scenario'}.xml`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const buildScenarioXML = (scenarioName, events) => {
        let xmlContent = `<?xml version="1.0" encoding="utf-8"?>\n`;
        xmlContent += `<ScenarioSequenceXML>\n`;
        xmlContent += `\t<ScenarioName>${scenarioName}</ScenarioName>\n`;

        events.forEach((event) => {
            const actionType = event.actionType;
            const actionValue = event.actionValue;
            const actionPrefix = actionType === 'sound' ? 'sound:' : 'anim:';

            xmlContent += `\t<ScenarioEventXML>\n`;
            xmlContent += `\t\t<time>${event.time}</time>\n`;
            xmlContent += `\t\t<target>${event.target}</target>\n`;
            xmlContent += `\t\t<action>${actionPrefix}${actionValue}</action>\n`;
            xmlContent += `\t\t<duration>${event.duration}</duration>\n`;
            xmlContent += `\t</ScenarioEventXML>\n`;
        });

        xmlContent += `</ScenarioSequenceXML>\n`;
        return xmlContent;
    };

    return (
        <div className="config-options-container">
            <div className="custom-heading">
                Manage Scenarios
            </div>
            <p className="custom-label" style={{width:"auto"}}>
                This page is dedicated to the management of scenarios. You can create new scenarios or edit existing scenarios. Scenarios are always saved locally as *.xml files. During a session, you can then select all scenarios saved in:
            </p>
            <p className="custom-explanation">
                vr-klassenzimmer\Assets\StreamingAssets\Config~\sequence.
            </p>

            <Divider/>

            <div className="config-section button-group">
                {/* NEW */}
                <p className="button-with-left-icon">
                    <Button onClick={handleNewScenario}>
                        <Icon icon="new-object" style={{ marginRight: "5px" }} />
                        New Scenario
                    </Button>
                </p>
                

                {/* LOAD */}
                <input
                    type="file"
                    accept=".xml"
                    id="file-input"
                    style={{ display: 'none' }}
                    onChange={handleLoadScenario}
                />
                <p className="button-with-left-icon">
                    <Button onClick={() => document.getElementById('file-input').click()}>
                        <Icon icon="import" style={{ marginRight: "5px" }} />
                        Load Scenario
                    </Button>
                </p>
                {/* SAVE */}
                <p className="button-with-left-icon">
                    <Button onClick={handleSaveScenario}>
                        <Icon icon="floppy-disk" style={{ marginRight: "5px" }} />
                        Save Scenario
                    </Button>
                </p>
            </div>

            <Divider />

            {/* NAME */}
            {showScenarioEditor && (
                <div className="config-section">
                    <label className="custom-label">Scenario Name</label>
                    <InputGroup
                        value={scenarioName}
                        onChange={(e) => setScenarioName(e.target.value)}
                        placeholder="Enter scenario name"
                    />
                    {/*<Divider />*/}
                </div>
            )}

            {/* ADD Event */}
            {showScenarioEditor && (
                <div className="config-section" style={{ justifyContent: "flex-end" }}>
                    <p className="add-button" >
                        <Button onClick={addScenarioEvent}>
                            <Icon icon="add" style={{ marginRight: "5px"}} />
                            Scenario Event
                        </Button>
                    </p>

                    {/* HEADLINE */}
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", fontSize: "12px", columnGap: "5px", marginBottom:"14px" }}>
                        <p className="header-item" style={{ width: "2%", color: "transparent" }}>.</p> {/* Drag Icon space */}
                        <p className="header-item" style={{ width: "12%" }}>
                            Start
                            <TeachRTooltip
                                content=
                                <div style={{width: "250px"}}>
                                    <p>The time t (in seconds) at which the event should start.</p>
                                    <p>The value is specified as an integer.</p>
                                    <p>As soon as the scenario is started, the specified action is triggered automatically t seconds later.</p>
                                    </div>
                                icon="info-sign"
                                iconColor="var(--highlight_1)"
                                tooltipDirection="top" />
                        </p>
                        <p className="header-item" style={{ width: "23%" }}>
                            Target
                            <TeachRTooltip
                                content=
                                    <div>
                                        <p>The target that should play the <b>audio</b> file (enviroment, students) or the <b>animation</b> (<u>students only</u>).</p>
                                        <p>Options:</p>
                                        <ul>
                                            <li>enviroment: invisible GameObject inside the classroom</li>
                                            <li>[01L] : A single student</li>
                                            <li>[01l, 05R, 02R]: A crowd of students</li>
                                            <li>random: A random student</li>
                                            <li>all: All students</li>
                                        </ul>
                                    </div>
                                icon="info-sign"
                                iconColor="var(--highlight_1)"
                                tooltipDirection="top" />
                        </p>
                        <p className="header-item" style={{ width: "12%" }}>
                            Type
                            <TeachRTooltip
                                content=
                                <div style={{ width: "250px" }}>
                                    Select whether an audio file or an animation is to be used by clicking on the corresponding icon.
                                </div>
                                icon="info-sign"
                                iconColor="var(--highlight_1)"
                                tooltipDirection="top" />
                        </p>
                        <p className="header-item" style={{ width: "30%"}}>
                            Filename
                            <TeachRTooltip
                                content=
                                <div style={{ width: "250px" }}>
                                    <p>Enter the audio file name (without extension) or the name of the animation.</p>
                                    <p>When saving, the tags <b>sound:</b> or <b>anim:</b> are automatically placed in front of the file name.</p>
                                    <p>When loading an xml file, the <b>sound:</b> or <b>anim:</b> tags are automatically removed.</p>
                                </div>
                                icon="info-sign"
                                iconColor="var(--highlight_1)"
                                tooltipDirection="top" />
                        </p>
                        <p className="header-item" style={{ width: "15%" }}>
                            Duration
                            <TeachRTooltip
                                content=
                                <div>
                                    <p>The Duration t (in seconds) is an optional specification (integer).</p>
                                    <p>If the value t = 0, the audio file or animation is played until its end.</p>
                                    <p>If, on the other hand, a value t <span>&gt;</span> 0 is specified, the event is automatically ended after t seconds.</p>
                                </div>
                                icon="info-sign"
                                iconColor="var(--highlight_1)"
                                tooltipDirection="top" />
                        </p>
                        <p className="header-item" style={{ width: "6%", color: "transparent" }}>.</p> {/* Delete Button space */}
                    </div>

                    {/* Drag & Drop Context for Scenario Events */}
                    <DragDropContext onDragEnd={handleOnDragEnd}>
                        <Droppable droppableId="scenarioEvents">
                            {(provided) => (
                                <div {...provided.droppableProps} ref={provided.innerRef}>
                                    {events.map((event, index) => (
                                        <Draggable key={index} draggableId={`event-${index}`} index={index}>
                                            {(provided) => (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                >
                                                    <ScenarioEvent
                                                        dragHandleProps={provided.dragHandleProps}
                                                        event={event}
                                                        onChange={(updatedEvent) =>
                                                            updateScenarioEvent(index, updatedEvent)
                                                        }
                                                        onDelete={() => deleteScenarioEvent(index)}
                                                    />
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    </DragDropContext>
                </div>
            )}
        </div>
    );
};

export default ConfigureScenario;
